import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardCreateStoreComponent } from '../create-store/create-store.component';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { environment } from '../../../environments/environment';
import { SubDomainPatternValidator } from '../../core/constants/custom-validators.constants';
import { Router } from '@angular/router';
import { DataService } from 'src/app/data.service';
import { DEALER_STATUS } from 'src/app/core/constants/data.constant';
import { reject } from 'underscore';
import { DealerService } from 'src/app/dealer.service';
import { StoreInfoService } from 'src/app/store-info.service';

@Component({
  selector: 'app-list-stores',
  templateUrl: './list-stores.component.html',
  styleUrls: ['./list-stores.component.scss'],
})
export class ListStoresComponent implements OnInit {
  bearer;

  stores: any = [];
  body = [];
  closeResult = '';
  loading = true;
  loadingUpdate = false;
  copied = false;
  store_id;
  totalSale;
  products: [];
  language_code = 'en_US';
  errorMsg = '';
  dealerId;
  switchToggle = false;
  storeSubdomain = environment.storeSubdomain;
  storeCountLimit = 1;
  dealerPlan;
  defaultStore;
  dealerStatus: string;
  status: string;
  featurePlan;
  partnerPlatformUrl;

  allowRemoveStore = false;
  allowCreateStore = false;

  StoreListUpdateRequestEvent;
  protected readonly environment = environment;

  items: any[] = []; // Your array of items

  // Create an array to hold form groups
  itemForms: FormGroup[] = [];
  dealer$ = this.dealerService.getDealer();
  storeList$ = this.storeInfoService.getStoreList();
  storeInfo$ = this.storeInfoService.getStoreInfos();

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    public utils: UtilitiesService,
    private router: Router,
    private dataService: DataService,
    private dealerService: DealerService,
    private storeInfoService: StoreInfoService
  ) {}

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');
    const info = JSON.parse(localStorage.getItem('5s-info'));
    this.dealerId = info.d_id;
    this.status = info.status;
    this.dealerStatus = DEALER_STATUS[this.status].status;
    this.defaultStore = localStorage.getItem('default_store');

    this.getTotalSale().then(() => {
      this.getStoreList();
      this.getDealerInfo();
      this.getStoreInfo(this.store_id);
    });
    this.svc
      .getProductLists(this.bearer, this.store_id, this.language_code)
      .subscribe(
        (res) => {
          this.products = res['data'];
        },
        (error) => {
          this.utils.errorUnauthorized();
        }
      );

    this.StoreListUpdateRequestEvent = this.dataService
      .getStoreListUpdateRequestEvent()
      .subscribe((item) => this.handleStoreListUpdateRequestEvent());
    this.dataService.getLocalStorageData().subscribe();
  }

  getDealerInfo() {
    this.dealer$.subscribe((res) => {
      this.dataService.updateDealerInfo(res);
      this.dataService.updateDealerPlan(res?.dealer_plan);
      this.dataService.updateDealerCredits(res?.dealer_credits);
      this.dataService.updateDealerSubStatus(res?.dealer_subscription_status);
      this.storeCountLimit = res?.dealer_plan?.store_number;
      this.partnerPlatformUrl = res?.config?.partner_platform_url;

      if (res?.dealer_plan?.feature_list.includes('multi-estore') === true) {
        this.allowCreateStore = true;
      }

      if (res.config?.partner_platform_url) {
        this.partnerPlatformUrl = res?.config?.partner_platform_url;
      }
    });
  }

  get canCreateStore(): boolean {
    return (
      this.isAllowCreate &&
      !this.storeLimitReached &&
      !this.isConvertedSuspended
    );
  }

  get storeLimitReached(): boolean {
    return this.dataService.storeAmount >= this.storeCountLimit;
  }

  get isConverted(): boolean {
    return this.dealerStatus === 'Converted';
  }

  get isSuspended(): boolean {
    return this.dealerStatus === 'Suspended';
  }

  get isConvertedSuspended(): boolean {
    return this.isConverted || this.isSuspended;
  }

  get isAllowCreate(): boolean {
    return this.allowCreateStore === true;
  }

  handleStoreListUpdateRequestEvent() {
    this.getStoreList(true);
  }

  async getTotalSale() {
    return new Promise((resolve, reject) => {
      this.svc.getTotalSalesByDealer(this.bearer, this.dealerId).subscribe(
        (res) => {
          this.totalSale = res['data'];
          resolve(true);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getReport(storeId) {
    let totalSale = 0;
    if (storeId !== undefined) {
      if (
        this.totalSale[storeId] !== undefined ||
        this.totalSale[storeId]?.length > 0
      ) {
        let data = this.totalSale[storeId];
        Object.keys(data).forEach((key) => {
          totalSale = totalSale + +data[key].total_price;
        });
      }
    }
    return totalSale;
  }

  // Function to get a specific form group
  getItemFormGroup(index: number): FormGroup {
    return this.itemForms[index];
  }

  updateItemFormGroup(index: number, data): void {
    const formGroup = this.getItemFormGroup(index);
    const updatedValues = {
      store_name: data.store_name,
      subdomain: data.subdomain,
      detailsCard: data.detailsCard,
      mainCard: data.mainCard,
      editButton: data.editButton,
    };
    formGroup.patchValue(updatedValues);
    this.storeInfoService.fetchStoreInfo();    
  }

  saveButtonStatus(index) {
    if (this.stores[index].saveLoading) {
      this.loadingUpdate = true;
      return true;
    }

    let status = false;
    Object.keys(this.itemForms[index].controls).forEach((key) => {
      if (
        this.itemForms[index].get(key)?.dirty &&
        this.itemForms[index].get(key).value !== this.stores[index][key]
      ) {
        status = true;
      }
    });
    return !(
      status &&
      this.stores[index].validatingStoreName &&
      this.stores[index].validatingSubDomain
    );
  }

  // Save function to update the item in the array
  saveItem(index: number) {
    this.loadingUpdate = true;
    this.stores[index].saveLoading = true;
    if (this.itemForms[index].value.store_name === '') {
      this.stores[index].validatingStoreName = false;
      return (this.stores[index].nameRequired = true);
    }
    if (this.itemForms[index].value.subdomain === '') {
      this.stores[index].validatingSubDomain = false;
      return (this.stores[index].URLRequired = true);
    }

    const updatedItem = this.getItemFormGroup(index).value;

    this.checkSubdomain(index).then((res) => {
      if (res) {
        this.svc
          .updateStoreDetails(
            updatedItem['store_id'],
            updatedItem['store_name'],
            updatedItem['subdomain'],
            this.bearer
          )
          .subscribe(
            (res) => {
              if (res['status'] === 'success') {
                this.utils.notify.showSuccess(
                  this.utils.translate('Updated Successfully!')
                );
                this.stores[index].editButton = !this.stores[index].editButton;
                this.storeInfoService.fetchStoreList();
                setTimeout(() => {
                  this.getStoreInfo(this.stores[index].store_id, index);
                  this.loadingUpdate = false;
                }, 1000);
              } else {
                this.utils.notify.showError('Error');
              }
              this.stores[index].saveLoading = false;
            },
            (error) => {
              this.errorMsg = error['error']['message'];
              this.utils.notify.showError(
                this.errorMsg,
                this.utils.translate('Update Failed!')
              );
            }
          );
      }
    });
  }
  async checkSubdomain(index) {
    if (
      this.itemForms[index].value.subdomain === this.stores[index].subdomain
    ) {
      return true;
    }

    const param = {
      subDomain: this.itemForms[index].value.subdomain,
    };

    return new Promise((resolve, reject) => {
      this.svc.validateSubDomain(this.bearer, param).subscribe(
        (res) => {
          if (!res['data']['available']) {
            this.stores[index].validatingSubDomain = false;
            this.stores[index].unavailableSubdomain = true;
            resolve(false);
          } else {
            this.stores[index].validatingSubDomain = true;
            this.stores[index].unavailableSubdomain = false;
            resolve(true);
          }
        },
        (err) => {
          this.stores[index].validatingSubDomain = false;
          reject(false);
        }
      );
    });
  }

  getStoreInfo(storeId, index = null) {
    this.storeInfo$.subscribe((res) => {
      if (res?.store_url !== undefined) {
        if (index !== null) {
          this.storeList$.subscribe((res) => {
            this.stores[index].store_name = res[index].store_name;
            this.stores[index].subdomain = res[index].subdomain;
            this.stores[index].store_url = res[index].store_url;
            this.updateItemFormGroup(index, this.stores[index]);
          });

          if (res.config?.partner_platform_url) {
            this.partnerPlatformUrl = res.config.partner_platform_url;
          }

          if (+storeId === +localStorage.getItem('store_id')) {
            localStorage.setItem('store_url', res.store_url);
            this.dataService.emitLocalStorageData(res);
          }
        }
      }
    });
  }

  urlValidation(index) {
    let url = this.itemForms[index].value.subdomain;
    let sanitizedUrl = url
      .trim()
      .replace(/[^a-zA-Z0-9-]/g, '')
      .replace(/--/g, '-');
    if (sanitizedUrl[0] === '-') {
      sanitizedUrl = sanitizedUrl.substr(1);
    }
    this.itemForms[index].get('subdomain').setValue(sanitizedUrl);
  }

  changeErrorStatus(index) {
    this.stores[index].validatingSubDomain = true;
    this.stores[index].URLRequired = false;
    this.stores[index].unavailableSubdomain = false;
    this.stores[index].validatingStoreName = true;
    this.stores[index].nameRequired = false;
  }

  cancelItem(index: number, content, back = false) {
    this.changeErrorStatus(index);
    const formGroup = this.getItemFormGroup(index);

    // Check for changes
    const changedFields: string[] = [];

    Object.keys(formGroup.controls).forEach((key) => {
      if (
        formGroup.get(key)?.dirty &&
        formGroup.get(key).value !== this.stores[index][key]
      ) {
        changedFields.push(key);
      }
    });

    if (changedFields.length > 0) {
      this.openModal(content, index);
    } else {
      if (back) {
        this.stores[index].editButton = false;
        this.changeCard(index);
      } else {
        this.stores[index].editButton = !this.stores[index].editButton;
        this.updateItemFormGroup(index, this.stores[index]);
      }
    }
  }

  // Function to create a form group for each item
  createItemFormGroup(item: any): FormGroup {
    return this.formBuilder.group({
      store_id: [item.store_id],
      plan_price: [item?.store_plan_info?.plan_price ?? 1.0],
      maintenance: [item?.maintenance],
      expired_at: [item?.expired_at],
      mainCard: true,
      detailsCard: false,
      editButton: false,
      store_name: [item.store_name, Validators.required],
      store_url: [item.store_url, Validators.required],
      subdomain: [
        item.subdomain,
        [
          Validators.required,
          SubDomainPatternValidator,
          Validators.minLength(5),
          Validators.maxLength(24),
        ],
      ],
      // Add more form controls if needed
    });
  }

  getStoreList(refresh = false) {
    this.storeList$.subscribe((res) => {
      const storeArray = Array.isArray(res) ? res : Object.values(res);
      storeArray.forEach((value) => {
        value.mainCard = true;
        value.detailsCard = false;
        value.editButton = false;
        value.plan_price = value.store_plan_info.plan_price;
        value.validatingSubDomain = true;
        value.validatingStoreName = true;
        value.saveLoading = false;
        value.URLRequired = false;
        value.nameRequired = false;
        value.unavailableSubdomain = false;
        value.totalPrice = this.getReport(value.store_id);
      });
      const storeData = Object.values(res);
      this.stores = this.items = storeData;
      this.dataService.emitStoreListUpdatedEvent(storeData);
      this.dataService.storeAmount = this.stores.length;

      // Initialize form groups
      this.items.forEach((item) => {
        const formGroup = this.createItemFormGroup(item);
        this.itemForms.push(formGroup);
      });
      this.loading = false;
    });
  }

  toggleStatus(storeId, maintenanceStatus) {
    const storeData = this.getStoreDataByStoreId(storeId);
    if (storeData.status === false) {
      this.utils.notify.showWarning(this.utils.translate('Please Subscribe!'));
      return false;
    }
    let status;
    let maintenance;
    if (maintenanceStatus == '1') {
      status = 1;
      maintenance = 0;
    } else {
      status = 1;
      maintenance = 1;
    }

    let body = {
      store_id: storeId,
      store_status: status,
      maintenance: maintenance,
    };
    return this.updateStoreStatus(body);
  }

  removeStore(index) {
    if (this.allowRemoveStore === false) {
      this.utils.notify.showError(
        this.utils.translate('Removal of this store is not allowed!')
      );
      return;
    }
    let data = this.stores[index];
    let body = {
      store_id: data.store_id,
      maintenance: data.maintenance,
      store_status: 0,
    };
    return this.updateStoreStatus(body, true, true);
  }

  async updateStoreStatus(body, message = false, remove = false) {
    let refresh = false;
    this.svc.updateStatus(body, this.bearer).subscribe(
      (res) => {
        if (remove) {
          refresh = true;
          if (+body['store_id'] === +this.dataService.storeId) {
            const storeData = this.getStoreDataByStoreId(this.defaultStore);
            this.dataService.emitLocalStorageData(storeData);
          }
        }
        this.storeInfoService.fetchStoreList();
        setTimeout(() => {
          if (message) {
            this.utils.notify.showSuccess('Updated Successfully!');
            this.storeInfoService.fetchStoreList();
          }
          this.getStoreList(refresh);
        }, 1000);
      },
      (error) => {
        let errorMsg = error['error']['message'];

        if (typeof errorMsg === 'object') {
          let msg = '';
          Object.keys(errorMsg).forEach((key) => {
            msg += errorMsg[key] + '\n';
          });
          errorMsg = msg;
        }
        this.utils.notify.showError(errorMsg);
      }
    );
  }

  toggleDefaultStore(storeId, status = false) {
    const storeData = this.getStoreDataByStoreId(storeId);
    if (storeData.status === false) {
      this.utils.notify.showWarning(this.utils.translate('Please Subscribe!'));
      return false;
    }

    this.switchToggle = false;
    if (status) {
      this.switchToggle = true;
      this.getStoreToggleStatus(storeId, true);
    } else {
      let body = {
        store_id: storeId,
        dealer_id: this.dealerId,
      };

      this.svc.updateDefaultStore(body, this.bearer).subscribe(
        (res) => {
          this.defaultStore = storeId;
          localStorage.setItem('default_store', storeId);
          this.switchStore(
            storeId,
            false,
            'Updated default store to "{0}" successfully.'
          );
          this.getStoreList();
        },
        (error) => {}
      );
    }
  }

  getStoreToggleStatus(id, pending = false) {
    if (pending) {
      return true;
    } else {
      if (this.stores.length < 2) {
        return false;
      }
      return this.defaultStore === id;
    }
  }

  checkRemoveStatus(storeId) {
    let status: boolean;
    if (this.stores.length < 2) {
      status = true;
    } else {
      status = +storeId === +this.defaultStore;
    }
    this.allowRemoveStore = !status;
    return status;
  }

  // getCreateStoreStatus(storeLength = 0) {
  //   if (storeLength === 1) {
  //     return this.canCreateStore && this.storeCountLimit !== this.stores.length;
  //   } else if (storeLength === 2) {
  //     return this.canCreateStore && this.storeCountLimit === this.stores.length;
  //   } else {
  //     return this.canCreateStore;
  //   }
  // }

  get dealerWhitelistStatus() {
    let feature = localStorage.getItem('feature');
    if (
      feature !== undefined &&
      feature !== null &&
      feature !== '[]' &&
      feature !== ''
    ) {
      let features = feature.split(',');
      let check = features.find((t) => t === 'create-multi-estore');
      return check !== undefined && check !== null;
    } else {
      return false;
    }
  }

  openModal(content, index) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'sm',
        backdrop: 'static',
        keyboard: false,
        windowClass: 'modal-customer',
        centered: true,
      })
      .result.then(
        (result) => {
          if (result === 'leave') {
            this.stores[index].editButton = !this.stores[index].editButton;
            this.changeCard(index);
          } else if (result === 'delete') {
            this.removeStore(index);
          }
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  gotoStore(url) {
    window.open(url, '_blank');
  }

  showCreateStore() {
    if (!this.canCreateStore) {
      this.utils.notify.showError(
        this.utils.translate(
          'Unable to create store. You have reached maximum store limit'
        )
      );
      return false;
    } else {
      this.modalService.open(DashboardCreateStoreComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        backdrop: 'static',
        size: 'lg',
      });
    }
  }

  changeCard(index) {
    if (this.stores[index].status === false) {
      this.utils.notify.showWarning(this.utils.translate('Please Subscribe!'));
      return false;
    }
    this.stores[index].mainCard = !this.stores[index].mainCard;
    this.stores[index].detailsCard = !this.stores[index].detailsCard;
    this.updateItemFormGroup(index, this.stores[index]);
  }

  editForm(type, index, content = null) {
    if (type === 'cancel') {
      return this.cancelItem(index, content);
    }
    this.stores[index].editButton = !this.stores[index].editButton;
    this.updateItemFormGroup(index, this.stores[index]);
    return this.stores[index];
  }

  validateStoreName(index) {
    this.stores[index].validatingStoreName = true;
    this.stores[index].nameRequired = false;
    if (this.itemForms[index].value.store_name === '') {
      this.stores[index].validatingStoreName = false;
      return (this.stores[index].nameRequired = true);
    }
  }

  validateDomain(index) {
    this.urlValidation(index);
    this.stores[index].saveLoading = false;
    this.stores[index].URLRequired = false;
    this.stores[index].unavailableSubdomain = false;
    this.stores[index].validatingSubDomain = true;
    if (this.itemForms[index].value.subdomain === '') {
      this.stores[index].validatingSubDomain = false;
      this.stores[index].unavailableSubdomain = false;
      this.stores[index].URLRequired = true;
    } else if (
      this.itemForms[index].value.subdomain.length < 5 ||
      this.itemForms[index].value.subdomain.length > 24
    ) {
      this.stores[index].validatingSubDomain = false;
    } else if (
      this.itemForms[index].value.subdomain !== this.stores[index].subdomain
    ) {
      this.stores[index].validatingSubDomain = true;
    } else {
      this.stores[index].unavailableSubdomain = false;
      this.stores[index].validatingSubDomain = true;
    }
  }

  getStoreDataByStoreId(storeId) {
    return this.stores.find((store) => {
      return +store?.store_id === +storeId;
    });
  }

  modifyStore(storeId) {
    const storeData = this.getStoreDataByStoreId(storeId);
    if (storeData.status === false) {
      this.utils.notify.showWarning(this.utils.translate('Please Subscribe!'));
      return false;
    }
    this.switchStore(storeId, false);
    this.router.navigate(['/dashboard/content-editor']);
  }

  switchStore(storeId, showWarning = false, message = '') {
    const storeData = this.getStoreDataByStoreId(storeId);
    this.utils.switchStore(storeId, storeData, showWarning, message);
  }
}
